import { openPremiumDashboard } from 'owa-whats-new';
import { isFeatureEnabled } from 'owa-feature-flags';
import { lazyMountAndShowFullOptions } from 'owa-options-view';
import { orchestrator } from 'satcheljs';

const upgradeUrl = 'https://premium.outlook.com';

export default orchestrator(openPremiumDashboard, async () => {
    if (isFeatureEnabled('auth-PremiumDashboardApril')) {
        lazyMountAndShowFullOptions.importAndExecute('premium', 'features');
    } else if (isFeatureEnabled('auth-PremiumDashboard')) {
        lazyMountAndShowFullOptions.importAndExecute('general', 'Premium');
    } else {
        window.open(upgradeUrl, '_blank');
    }
});
